<div class="guest-header">
  <div class="container">
    <nav
      class="navbar navbar-expand-lg navbar-light container d-flex align-items-center gap-3 w-100"
    >
      <!-- Logo -->
      <a [routerLink]="APP_ROUTES.GUEST.ROOT">
        <img [src]="ASSETS.logo" alt="Company Logo" class="guest-header__logo" />
      </a>
      <div class="d-flex align-items-center justify-content-end gap-2">
        <a
          [routerLink]="APP_ROUTES.GUEST.REQUEST_DEMO"
          target="_blank"
          rel="noopener noreferrer"
          class="guest-header__demo"
        >
          Request Demo
        </a>
        @if(!mobileMenuOpen) {
        <button
          class="navbar-toggler"
          type="button"
          (click)="toggleMobileMenu()"
          [attr.aria-expanded]="mobileMenuOpen"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        } @else {
          <button
          class="guest-header__mobile-close"
          (click)="toggleMobileMenu()"
          aria-label="Close menu"
        >
          <i class="bi bi-x-lg"></i>
        </button>
        }
      </div>

      <div class="collapse navbar-collapse d-none d-lg-block" id="guestNavbar">
        <div class="guest-header__menu">
          <ul class="navbar-nav guest-header__actions">
            @for (item of leftMenuItems; track item.label) {
            <li
              class="nav-item guest-header__dropdown-container"
              [class.has-dropdown]="item.hasDropdown"
            >
              @if (item.hasDropdown) {
              <a
                href="javascript:void(0)"
                class="guest-header__link guest-header__dropdown-trigger"
                [class.active]="activeDropdown === item.label.toLowerCase()"
                (click)="toggleDropdown(item.label.toLowerCase(), $event)"
                (mouseenter)="onMouseEnter(item.label.toLowerCase())"
                (mouseleave)="onMouseLeave()"
                (mouseover)="onMouseEnter(item.label.toLowerCase())"
              >
                {{ item.label }}
                <i
                  class="bi ms-1 guest-header__chevron"
                  [class.bi-chevron-down]="activeDropdown !== item.label.toLowerCase()"
                  [class.bi-chevron-up]="activeDropdown === item.label.toLowerCase()"
                ></i>
              </a>

              <!-- Platform Dropdown -->
              @if (item.label === 'Platform' && activeDropdown === 'platform') {
              <div
                class="guest-header__dropdown"
                (mouseenter)="onDropdownMouseEnter()"
                (mouseleave)="onDropdownMouseLeave()"
              >
                <div class="guest-header__dropdown-content guest-header__dropdown-content--platform">
                  <div class="guest-header__dropdown-body guest-header__dropdown-body--platform">
                    <div class="guest-header__dropdown-section guest-header__dropdown-section--product">
                      <h3 class="guest-header__dropdown-title">Product</h3>
                      <div class="guest-header__dropdown-grid">
                        @for (item of platformProductItems; track item.label) {
                        <a
                        [routerLink]="[
                        APP_ROUTES.GUEST.PRODUCT,
                        APP_ROUTES.GUEST.PLATFORM.ROOT,
                        APP_ROUTES.GUEST.PLATFORM.FEATURES
                        ]"
                          class="guest-header__dropdown-card"
                          (click)="closeDropdown(); closeMenu()"
                        >
                          <span class="guest-header__dropdown-card-icon">
                            <img [src]="item.iconUrl" alt="" />
                          </span>
                          <span class="guest-header__dropdown-text">
                            <span class="guest-header__dropdown-label">{{ item.label }}</span>
                            <span class="guest-header__dropdown-subtitle">{{ item.subtitle }}</span>
                          </span>
                        </a>
                        }
                      </div>
                      <a
                        [routerLink]="[
                          APP_ROUTES.GUEST.PRODUCT,
                          APP_ROUTES.GUEST.PLATFORM.ROOT,
                          APP_ROUTES.GUEST.PLATFORM.FEATURES
                        ]"
                        class="guest-header__dropdown-view-all"
                        (click)="closeDropdown(); closeMenu()"
                      >
                        View all features
                        <i class="bi bi-arrow-right text-lg"></i>
                        <!-- <img class="guest-header__dropdown-view-all-icon" [src]="dropdownAssets.platformArrowIcon" alt="" /> -->
                      </a>
                    </div>
                    <div class="guest-header__dropdown-aside">
                      <div class="guest-header__dropdown-aside-column">
                        <h3 class="guest-header__dropdown-title">Industries</h3>
                        <ul class="guest-header__dropdown-list guest-header__dropdown-list--simple">
                          @for (item of platformIndustries; track item.label) {
                          <li class="guest-header__dropdown-item">
                                <a
                                  [routerLink]="[
                                  APP_ROUTES.GUEST.PRODUCT,
                                  APP_ROUTES.GUEST.INDUSTRIES.ROOT,
                                  APP_ROUTES.GUEST.INDUSTRIES.ALL
                                ]"
                              class="guest-header__dropdown-link-simple"
                              (click)="closeDropdown(); closeMenu()"
                              >{{ item.label }}</a
                            >
                          </li>
                          }
                        </ul>
                        <a
                          [routerLink]="[
                            APP_ROUTES.GUEST.PRODUCT,
                            APP_ROUTES.GUEST.INDUSTRIES.ROOT,
                            APP_ROUTES.GUEST.INDUSTRIES.ALL
                          ]"
                          class="guest-header__dropdown-link-simple guest-header__dropdown-link-simple--arrow"
                          (click)="closeDropdown(); closeMenu()"
                        >
                          All Industries
                          <i class="bi bi-arrow-right text-lg"></i>
                          <!-- <img class="guest-header__dropdown-inline-icon" [src]="dropdownAssets.platformArrowIconAlt" alt="" /> -->
                        </a>
                      </div>
                      <div class="guest-header__dropdown-aside-column">
                        <h3 class="guest-header__dropdown-title">Use Cases</h3>
                        <ul class="guest-header__dropdown-list guest-header__dropdown-list--simple">
                          @for (item of platformUseCases; track item.label) {
                          <li class="guest-header__dropdown-item">
                            <a
                            [routerLink]="[
                            APP_ROUTES.GUEST.PRODUCT,
                            APP_ROUTES.GUEST.USE_CASES.ROOT,
                            APP_ROUTES.GUEST.USE_CASES.ALL
                            ]"
                              class="guest-header__dropdown-link-simple"
                              (click)="closeDropdown(); closeMenu()"
                              >{{ item.label }}</a
                            >
                          </li>
                          }
                        </ul>
                        <a
                          [routerLink]="[
                            APP_ROUTES.GUEST.PRODUCT,
                            APP_ROUTES.GUEST.USE_CASES.ROOT,
                            APP_ROUTES.GUEST.USE_CASES.ALL
                          ]"
                          class="guest-header__dropdown-link-simple guest-header__dropdown-link-simple--arrow"
                          (click)="closeDropdown(); closeMenu()"
                        >
                          All Use Cases
                          <i class="bi bi-arrow-right text-lg"></i>
                          <!-- <img class="guest-header__dropdown-inline-icon" [src]="dropdownAssets.platformArrowIconAlt" alt="" /> -->
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="guest-header__dropdown-footer guest-header__dropdown-footer--platform">
                    <a
                      [routerLink]="[APP_ROUTES.AUTH.ROOT, APP_ROUTES.AUTH.SIGNUP]"
                      (click)="closeDropdown(); closeMenu()"
                      >Sign up free account</a
                    >
                    <span class="guest-header__dropdown-footer-separator"></span>
                    <a
                      [routerLink]="APP_ROUTES.GUEST.PRICING"
                      (click)="closeDropdown(); closeMenu()"
                      >View Pricing</a
                    >
                    <span class="guest-header__dropdown-footer-separator"></span>
                    <a
                      [routerLink]="APP_ROUTES.GUEST.REQUEST_DEMO"
                      target="_blank"
                      rel="noopener noreferrer"
                      (click)="closeDropdown(); closeMenu()"
                      >Product Demo</a
                    >
                  </div>
                </div>
              </div>
              }

              <!-- Resources Dropdown -->
              @if (item.label === 'Resources' && activeDropdown === 'resources') {
              <div
                class="guest-header__dropdown guest-header__dropdown-resources"
                (mouseenter)="onDropdownMouseEnter()"
                (mouseleave)="onDropdownMouseLeave()"
              >
                <div class="guest-header__dropdown-content guest-header__dropdown-content--resources">
                  <div class="guest-header__dropdown-body guest-header__dropdown-body--resources">
                    <div class="guest-header__dropdown-section">
                      <h3 class="guest-header__dropdown-title">Product</h3>
                      <div class="guest-header__dropdown-card-list">
                        @for (item of resourcesProductItems; track item.label) {
                        <a
                          [routerLink]="item.routerLink"
                          class="guest-header__dropdown-card"
                          (click)="closeDropdown(); closeMenu()"
                        >
                          <span class="guest-header__dropdown-card-icon guest-header__dropdown-card-icon--yellow">
                            <img [src]="item.iconUrl" alt="" />
                          </span>
                          <span class="guest-header__dropdown-text">
                            <span class="guest-header__dropdown-label">{{ item.label }}</span>
                            <span class="guest-header__dropdown-subtitle">{{ item.subtitle }}</span>
                          </span>
                        </a>
                        }
                      </div>
                    </div>
            
                    <div class="guest-header__dropdown-aside guest-header__dropdown-aside--resources">
                      <div class="guest-header__dropdown-aside-column">
                        <h3 class="guest-header__dropdown-title">Support</h3>
                        <div class="guest-header__dropdown-card-list">
                          @for (item of resourcesSupportItems; track item.label) {
                          <a
                            [routerLink]="item.routerLink"
                            class="guest-header__dropdown-card"
                            (click)="closeDropdown(); closeMenu()"
                          >
                            <span class="guest-header__dropdown-card-icon guest-header__dropdown-card-icon--yellow">
                              <img [src]="item.iconUrl" alt="" />
                            </span>
                            <span class="guest-header__dropdown-text">
                              <span class="guest-header__dropdown-label">{{ item.label }}</span>
                              <span class="guest-header__dropdown-subtitle">{{ item.subtitle }}</span>
                            </span>
                          </a>
                          }
                        </div>
                      </div>
                      <div class="guest-header__dropdown-aside-column">
                        <h3 class="guest-header__dropdown-title">Company</h3>
                        <div class="guest-header__dropdown-card-list">
                          @for (item of resourcesCompanyItems; track item.label) {
                          <a
                            [routerLink]="item.routerLink"
                            class="guest-header__dropdown-card"
                            (click)="closeDropdown(); closeMenu()"
                          >
                            <span class="guest-header__dropdown-card-icon guest-header__dropdown-card-icon--yellow">
                              <img [src]="item.iconUrl" alt="" />
                            </span>
                            <span class="guest-header__dropdown-text">
                              <span class="guest-header__dropdown-label">{{ item.label }}</span>
                              <span class="guest-header__dropdown-subtitle">{{ item.subtitle }}</span>
                            </span>
                          </a>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="guest-header__dropdown-footer guest-header__dropdown-footer--resources">
                    <a
                      [routerLink]="[APP_ROUTES.AUTH.ROOT, APP_ROUTES.AUTH.SIGNUP]"
                      (click)="closeDropdown(); closeMenu()"
                      >Sign up free account</a
                    >
                    <span class="guest-header__dropdown-footer-separator"></span>
                    <a
                      [routerLink]="APP_ROUTES.GUEST.PRICING"
                      (click)="closeDropdown(); closeMenu()"
                      >View Pricing</a
                    >
                    <span class="guest-header__dropdown-footer-separator"></span>
                    <a
                      [routerLink]="APP_ROUTES.GUEST.REQUEST_DEMO"
                      target="_blank"
                      rel="noopener noreferrer"
                      (click)="closeDropdown(); closeMenu()"
                      >Product Demo</a
                    >
                  </div>
                </div>
              </div>
              }
            
            } @else {
              <a
                [routerLink]="item.routerLink"
                class="guest-header__link"
                [routerLinkActive]="['active']"
                [routerLinkActiveOptions]="{ exact: true }"
                (click)="closeMenu()"
              >
                {{ item.label }}
              </a>
              }
            </li>
            }
          </ul>
          <ul class="navbar-nav guest-header__actions">
            <li class="nav-item p-0 m-0">
              <a
                (click)="signIn()"
                href="javascript:void(0)"
                class="guest-header__link"
                [routerLinkActive]="['active']"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                Login</a
              >
            </li>
            <li class="nav-item">
              <a
                (click)="signUp()"
                href="javascript:void(0)"
                class="guest-header__signup"
                [routerLinkActive]="['active']"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                Sign up free</a
              >
            </li>
            <li class="nav-item">
              <a
                [routerLink]="APP_ROUTES.GUEST.REQUEST_DEMO"
                target="_blank"
                rel="noopener noreferrer"
                class="guest-header__request-demo"
              >
                Request Demo</a
              >
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>

  <!-- Mobile Menu Overlay -->
  @if (mobileMenuOpen) {
  <div class="guest-header__mobile-overlay">
    <!-- <div class="guest-header__mobile-header">
      <a [routerLink]="APP_ROUTES.GUEST.ROOT" (click)="closeMenu()">
        <img [src]="ASSETS.logo" alt="Company Logo" class="guest-header__mobile-logo" />
      </a>
      <div class="guest-header__mobile-header-actions">
        <a
          [routerLink]="APP_ROUTES.GUEST.REQUEST_DEMO"
          target="_blank"
          rel="noopener noreferrer"
          class="guest-header__mobile-demo-btn"
          (click)="closeMenu()"
        >
          Request Demo
        </a>
        <button
          class="guest-header__mobile-close"
          (click)="toggleMobileMenu()"
          aria-label="Close menu"
        >
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
    </div> -->

    <div class="guest-header__mobile-content">
      @if (!mobileActiveCategory) {
      <!-- Main Menu -->
      <ul class="guest-header__mobile-nav">
        @for (item of leftMenuItems; track item.label) {
        <li class="guest-header__mobile-nav-item">
          @if (item.hasDropdown) {
          <a
            href="javascript:void(0)"
            class="guest-header__mobile-nav-link"
            (click)="openMobileSection(item.label.toLowerCase())"
          >
            {{ item.label }}
            <!-- <img [src]="mobileMenuAssets.arrowRight" alt="" class="guest-header__mobile-nav-arrow" /> -->
            <i class="bi bi-chevron-right"></i>
          </a>
          } @else {
          <a
            [routerLink]="item.routerLink"
            class="guest-header__mobile-nav-link"
            (click)="closeMenu()"
          >
            {{ item.label }}
          </a>
          }
        </li>
        }
        <!-- <li class="guest-header__mobile-nav-item">
          <a
            href="javascript:void(0)"
            class="guest-header__mobile-nav-link"
          >
            Language
            <img [src]="mobileMenuAssets.arrowRightAlt" alt="" class="guest-header__mobile-nav-arrow" />
          </a>
        </li> -->
        <li class="guest-header__mobile-nav-item">
          <a
            (click)="signIn(); closeMenu()"
            href="javascript:void(0)"
            class="guest-header__mobile-nav-link"
          >
            Login
          </a>
        </li>
      </ul>

      <!-- CTA Buttons -->
      <div class="guest-header__mobile-cta">
        <a
          (click)="signUp(); closeMenu()"
          href="javascript:void(0)"
          class="guest-header__mobile-cta-btn guest-header__mobile-cta-btn--signup"
        >
          Sign up free
        </a>
        <a
          [routerLink]="APP_ROUTES.GUEST.REQUEST_DEMO"
          target="_blank"
          rel="noopener noreferrer"
          class="guest-header__mobile-cta-btn guest-header__mobile-cta-btn--demo"
          (click)="closeMenu()"
        >
          Request Demo
        </a>
      </div>
      } @else {
      <!-- Category View (Platform/Resources) -->
      <div class="guest-header__mobile-category">
        <div class="guest-header__mobile-category-header">
          <a
            href="javascript:void(0)"
            class="guest-header__mobile-back"
            (click)="backToMobileMenu()"
          >
            <!-- <img [src]="mobileMenuAssets.arrowBack" alt="" class="guest-header__mobile-back-icon" /> -->
            <i class="bi bi-chevron-left"></i>
            Back to menu
          </a>
          <span class="guest-header__mobile-category-title">{{
            mobileActiveCategory === 'platform' ? 'Platform' : 'Resources'
          }}</span>
        </div>
        <div class="guest-header__mobile-sections">
          @if (mobileActiveCategory === 'platform') {
          <div class="guest-header__mobile-platform">
            <div class="guest-header__mobile-platform-section">
              <div class="guest-header__mobile-platform-header">
                <span>Product</span>
                <!-- <img [src]="mobileMenuAssets.arrowDown" alt="" class="guest-header__mobile-platform-arrow" /> -->
              </div>
              <div class="guest-header__mobile-platform-list">
                @for (item of platformProductItems; track item.label) {
                <a
                  [routerLink]="item.routerLink"
                  class="guest-header__mobile-section-item"
                  (click)="closeMenu()"
                >
                  <span class="guest-header__mobile-item-icon">
                    <!-- <img [src]="dropdownAssets.platformItemIcon" alt="" /> -->
                    <img [src]="item.iconUrl" alt="" />
                  </span>
                  <span class="guest-header__mobile-item-content">
                    <span class="guest-header__mobile-item-title">{{ item.label }}</span>
                    <span class="guest-header__mobile-item-subtitle">{{ item.subtitle }}</span>
                  </span>
                </a>
                }
              </div>
              <a
                [routerLink]="[
                  APP_ROUTES.GUEST.PRODUCT,
                  APP_ROUTES.GUEST.PLATFORM.ROOT,
                  APP_ROUTES.GUEST.PLATFORM.FEATURES
                ]"
                class="guest-header__mobile-platform-view-all"
                (click)="closeMenu()"
              >
                View all features
                <!-- <img [src]="mobileMenuAssets.viewAllArrow" alt="" /> -->
                <i class="bi bi-chevron-right"></i>
              </a>
            </div>
            <div class="guest-header__mobile-platform-secondary">
              <div class="guest-header__mobile-platform-column">
                <h3>Industries</h3>
                <ul>
                  @for (item of platformIndustries; track item.label) {
                  <li>
                    <a [routerLink]="item.routerLink" (click)="closeMenu()">{{ item.label }}</a>
                  </li>
                  }
                  <li>
                    <a
                      [routerLink]="[
                        APP_ROUTES.GUEST.PRODUCT,
                        APP_ROUTES.GUEST.INDUSTRIES.ROOT,
                        APP_ROUTES.GUEST.INDUSTRIES.ALL
                      ]"
                      (click)="closeMenu()"
                      class="guest-header__mobile-platform-inline-link"
                    >
                      All Industries
                      <!-- <img [src]="mobileMenuAssets.viewAllArrowAlt" alt="" /> -->
                      <i class="bi bi-chevron-right"></i>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="guest-header__mobile-platform-divider"></div>
              <div class="guest-header__mobile-platform-column">
                <h3>Use Cases</h3>
                <ul>
                  @for (item of platformUseCases; track item.label) {
                  <li>
                    <a [routerLink]="item.routerLink" (click)="closeMenu()">{{ item.label }}</a>
                  </li>
                  }
                  <li>
                    <a
                      [routerLink]="[
                        APP_ROUTES.GUEST.PRODUCT,
                        APP_ROUTES.GUEST.USE_CASES.ROOT,
                        APP_ROUTES.GUEST.USE_CASES.ALL
                      ]"
                      (click)="closeMenu()"
                      class="guest-header__mobile-platform-inline-link"
                    >
                      All Use Cases
                      <!-- <img [src]="mobileMenuAssets.viewAllArrowAlt" alt="" /> -->
                      <i class="bi bi-chevron-right"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          } @else if (mobileActiveCategory === 'resources') {
          <div class="guest-header__mobile-resources">
            <div class="guest-header__mobile-resources-section">
              <h3>Product</h3>
              <div class="guest-header__mobile-resources-list">
                @for (item of resourcesProductItems; track item.label) {
                <a
                  [routerLink]="item.routerLink"
                  class="guest-header__mobile-section-item"
                  (click)="closeMenu()"
                >
                  <span class="guest-header__mobile-item-icon">
                    <img [src]="item.iconUrl" alt="" />
                  </span>
                  <span class="guest-header__mobile-item-content">
                    <span class="guest-header__mobile-item-title">{{ item.label }}</span>
                    <span class="guest-header__mobile-item-subtitle">{{ item.subtitle }}</span>
                  </span>
                </a>
                }
              </div>
            </div>
            <div class="guest-header__mobile-resources-section">
              <h3>Support</h3>
              <div class="guest-header__mobile-resources-list">
                @for (item of resourcesSupportItems; track item.label) {
                <a
                  [routerLink]="item.routerLink"
                  class="guest-header__mobile-section-item"
                  (click)="closeMenu()"
                >
                  <span class="guest-header__mobile-item-icon">
                    <img [src]="item.iconUrl" alt="" />
                  </span>
                  <span class="guest-header__mobile-item-content">
                    <span class="guest-header__mobile-item-title">{{ item.label }}</span>
                    <span class="guest-header__mobile-item-subtitle">{{ item.subtitle }}</span>
                  </span>
                </a>
                }
              </div>
            </div>
            <div class="guest-header__mobile-resources-section">
              <h3>Company</h3>
              <div class="guest-header__mobile-resources-list">
                @for (item of resourcesCompanyItems; track item.label) {
                <a
                  [routerLink]="item.routerLink"
                  class="guest-header__mobile-section-item"
                  (click)="closeMenu()"
                >
                  <span class="guest-header__mobile-item-icon">
                    <img [src]="item.iconUrl" alt="" />
                  </span>
                  <span class="guest-header__mobile-item-content">
                    <span class="guest-header__mobile-item-title">{{ item.label }}</span>
                    <span class="guest-header__mobile-item-subtitle">{{ item.subtitle }}</span>
                  </span>
                </a>
                }
              </div>
            </div>
          </div>
          }
        </div>
        <div class="guest-header__mobile-footer">
          <a
            [routerLink]="[APP_ROUTES.AUTH.ROOT, APP_ROUTES.AUTH.SIGNUP]"
            (click)="closeMenu()"
          >
            Sign up free account
          </a>
          <span class="guest-header__mobile-footer-separator"></span>
          <a
            [routerLink]="APP_ROUTES.GUEST.PRICING"
            (click)="closeMenu()"
          >
            View Pricing
          </a>
          <span class="guest-header__mobile-footer-separator"></span>
          <a
            [routerLink]="APP_ROUTES.GUEST.REQUEST_DEMO"
            target="_blank"
            rel="noopener noreferrer"
            (click)="closeMenu()"
          >
            Product Demo
          </a>
        </div>
      </div>
      }
    </div>
  </div>
  }
</div>
